<ng-container>
  <div class="custom-button">
    <app-custom-button [title]="label" [severity]="severity" [icon]="icon" [label]="label" [variant]="variant"
      [width]="width" [disabled]="disabled" (onClick)="uploadAndResize()"></app-custom-button>
  </div>
</ng-container>